export const ITEMS_PER_PAGE = 25;
export const MAX_VISIBLE_PAGE_BUTTONS = 5;